module.exports = __webpack_public_path__ + "img/26.dd3d5ae3.png";